import VerifiedIcon from "../../../../../../../assets/svg/VerifiedIcon";
import { MetricItem } from "../utils/constants";

const TicketMetric = ({ metricsData }: { metricsData: MetricItem[] }) => {
  return (
    <>
      {metricsData?.map((item) => {
        const isTotal = !item?.stageKey;
        const hasBgColor = !isTotal && !!item?.bgColor;

        return (
          <div
            key={item?.stageKey ?? "total"}
            className="flex flex-row items-center gap-2"
          >
            <div
              className={`flex flex-col w-full ${isTotal ? "gap-1" : "gap-2.5"} border border-border-gray dark:border-border-gray-dk rounded-[8px] py-2.5 h-[75px] px-3`}
              style={hasBgColor ? { backgroundColor: item.bgColor } : undefined}
            >
              <h6
                className={`${isTotal ? "text-[24px]" : "text-2xl"} font-medium whitespace-nowrap ${hasBgColor ? "text-white" : "text-verba-indigo dark:text-verba-indigo-dk"}`}
              >
                {item?.value}
              </h6>
              <h6
                className={`text-sm font-medium whitespace-nowrap flex items-center gap-1 ${hasBgColor ? "text-white" : "text-verba-indigo dark:text-verba-indigo-dk"}`}
              >
                {item?.stageKey === "closed" && (
                  <VerifiedIcon className="w-3 h-3" />
                )}
                {item?.label}
              </h6>
            </div>
            {isTotal && (
              <div className="h-4 w-px bg-border-gray dark:bg-border-gray-dk" />
            )}
          </div>
        );
      })}
    </>
  );
};

export default TicketMetric;
